export const NOUNS = [
    "Penguin",
    "Beast",
    "Dragon",
    "Cactus",
    "Volcano",
    "Wizard",
    "Rocket",
    "Banana",
    "Unicorn",
    "Jellyfish",
    "Pirate",
    "Otter",
    "Panda",
    "Phoenix",
    "Ninja",
    "Giraffe",
    "Sloth",
    "Squirrel",
    "Robot",
    "Alien",
    "Taco",
    "Pancake",
    "Donut",
    "Penguin",
    "Octopus",
    "Goblin",
    "Knight",
    "Pirate",
    "Butterfly",
    "Narwhal",
    "Platypus",
    "Hedgehog",
    "Llama",
    "Wolf",
    "Fox",
    "Tiger",
    "Dragonfly",
    "Seahorse",
    "Flamingo",
    "Koala",
    "Bear",
    "Monkey",
    "Frog",
    "Zebra",
    "Cat",
    "Dog",
    "Eagle",
    "Beetle",
    "Turtle",
    "Starfish",
    "Moose",
    "Croissant",
    "Hamster",
    "Lobster",
    "Owl",
    "Sparrow",
    "Raven",
    "Hawk",
    "Bee",
    "Chameleon",
    "Gecko",
    "Panda",
    "Moth",
    "Hedgehog",
    "Raven",
    "Iguana",
    "Seahorse",
    "Cricket",
    "Spider",
    "Scorpion",
    "Antelope",
    "Kangaroo",
    "Wombat",
    "Puffin",
    "Mole",
    "Seahorse",
    "Cricket",
    "Mole",
    "Shark",
    "Orca",
    "Falcon",
    "Starling",
    "Lobster",
    "Toad",
    "Ox",
    "Donkey",
    "Jaguar",
    "Otter",
    "Seal",
    "Walrus",
    "Hedgehog",
    "Mouse",
    "Rat",
    "Snail",
    "Duck",
    "Rooster",
    "Goose",
    "Turkey",
    "Alpaca",
    "Viper",
    "Crocodile"
];

export const ADJECTIVES = [
    "Witty",
    "Silly",
    "Happy",
    "Snappy",
    "Grumpy",
    "Zany",
    "Clever",
    "Sleepy",
    "Quirky",
    "Funky",
    "Spicy",
    "Bouncy",
    "Fuzzy",
    "Cheeky",
    "Sneaky",
    "Fluffy",
    "Brave",
    "Zesty",
    "Crafty",
    "Lively",
    "Sassy",
    "Jazzy",
    "Chill",
    "Quirky",
    "Loud",
    "Silent",
    "Smooth",
    "Spunky",
    "Merry",
    "Peppy",
    "Dashing",
    "Bright",
    "Gleeful",
    "Odd",
    "Eager",
    "Fancy",
    "Shiny",
    "Posh",
    "Bold",
    "Playful",
    "Cranky",
    "Nutty",
    "Fierce",
    "Wild",
    "Sweet",
    "Cool",
    "Bizarre",
    "Hilarious",
    "Shy",
    "Dainty",
    "Jumpy",
    "Weird",
    "Brave",
    "Reluctant",
    "Noisy",
    "Hyper",
    "Radiant",
    "Bubbly",
    "Electric",
    "Flamboyant",
    "Fearless",
    "Vivacious",
    "Naughty",
    "Whimsical",
    "Delicate",
    "Bossy",
    "Jolly",
    "Cheery",
    "Mischievous",
    "Breezy",
    "Vibrant",
    "Eccentric",
    "Rowdy",
    "Clumsy",
    "Stubborn",
    "Frisky",
    "Giddy",
    "Zippy",
    "Plucky",
    "Happy",
    "Flashy",
    "Gallant",
    "Energetic",
    "Radiant",
    "Goofy",
    "Daring",
    "Resourceful",
    "Optimistic",
    "Perky",
    "Vivacious",
    "Cheeky",
    "Carefree",
    "Reckless",
    "Spirited",
    "Crafty",
    "Hyperactive",
    "Funky",
    "Peaceful",
    "Bright",
    "Reckless"
];